<template>
  <div class="pie-chart-wrapper">
    <div id="chart">
      <apexchart type="pie" :height="height" :options="chartOptions" :series="series"></apexchart>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicPieChart',
  props: {
    value: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    labelField: {
      type: String,
      default: 'label'
    },
    valueField: {
      type: String,
      default: 'value'
    },
    height: {
      type: Number,
      default: 300
    },
    colors: {
      type: Array,
      default: () => ['#0058FF', '#29CB97', '#FFC700', '#F99600', '#9CA0A4']
    },
    showDataLabels: {
      type: Boolean,
      default: true
    },
    legendPosition: {
      type: String,
      default: 'right'
    },
    legendWidth: {
      type: String,
      default: 'auto'
    }
  },
  computed: {
    series() {
      return this.value.map(item => Number(item[this.valueField]) || 0);
    },
    labels() {
      return this.value.map(item => item[this.labelField]);
    },
    chartOptions() {
      return {
        chart: {
          type: 'pie',
          fontFamily: 'Helvetica, Arial, sans-serif',
        },
        labels: this.labels,
        colors: this.colors,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 250
            },
            legend: {
              position: this.legendPosition
            }
          }
        }],
        dataLabels: {
          enabled: this.showDataLabels,
          formatter: function(val) {
            return val.toFixed(1) + "%"
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val.toFixed(1) + "%"
            }
          }
        },
        legend: {
          position: this.legendPosition,
          offsetY: 0,
          formatter: function(seriesName, opts) {
            // 범례에 구분값과 점유율을 함께 표시
            return `${seriesName} : ${opts.w.globals.series[opts.seriesIndex].toFixed(1)}%`;
          },
          offsetX: 0,
          horizontalAlign: 'center',
          verticalAlign: 'middle',
          width: this.legendWidth,
        },
        title: {
          text: this.title,
          align: 'center',
          style: {
            fontSize: '16px',
            fontWeight: 500
          }
        },
      };
    }
  }
}
</script>

<style lang="scss">
.pie-chart-wrapper {
  .apexcharts-canvas {
    margin: 0 auto;
  }

  /* 범례 수직 중앙 정렬을 위한 스타일 */
  .apexcharts-legend {
    height: 100% !important;
    position: absolute !important;
    top: 0 !important;
    transform: none !important;
  }

  /* 범례가 오른쪽에 위치할 경우 */
  .apexcharts-legend.apx-legend-position-right {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    right: 0 !important;
  }

  /* 범례가 왼쪽에 위치할 경우 */
  .apexcharts-legend.apx-legend-position-left {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    left: 0 !important;
  }

  /* 범례가 상단에 위치할 경우 */
  .apexcharts-legend.apx-legend-position-top {
    top: 0 !important;
  }

  /* 범례가 하단에 위치할 경우 */
  .apexcharts-legend.apx-legend-position-bottom {
    bottom: 0 !important;
    top: auto !important;
  }

  .apexcharts-legend-text {
    font-size: 13px !important;
  }
}
</style>
